var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useQuery } from '@apollo/client/react';
import { ApprovalRequestStatus, DocumentType, SignRequestStatus } from 'shared/domains/apollo/generated/types';
import { useAccount } from 'shared/domains/users';
import { PleditorDownloadAvailableDataDocument } from './PleditorDownloadAvailableData.gql';
const APPROVAL_LOCKED_STATUSES = [ApprovalRequestStatus.Pending, ApprovalRequestStatus.Approved];
const ESIGNING_LOCKED_STATUSES = [
    SignRequestStatus.Creating,
    SignRequestStatus.Pending,
    SignRequestStatus.Signed,
    SignRequestStatus.Cancelling,
];
export const usePleditorDownloadAvailable = (documentId) => {
    const { data: accountData } = useAccount();
    const { companyId } = accountData;
    const _a = useQuery(PleditorDownloadAvailableDataDocument, {
        variables: { companyId, documentId },
    }), { data } = _a, rest = __rest(_a, ["data"]);
    const { fileSystemDocument, approvalRequest, signRequests = [], fileSystemCompanyFeatures = [] } = data || {};
    const { type, name } = fileSystemDocument || {};
    const { status: approvalStatus } = approvalRequest || {};
    const { status: signRequestStatus } = signRequests[0] || {};
    const isPleditorDownloadAvailable = fileSystemCompanyFeatures.some(({ feature }) => feature === 'IMPORT_EXPORT') &&
        (type === DocumentType.Composed || type === DocumentType.Freetext);
    const isApprovalLocked = approvalStatus && APPROVAL_LOCKED_STATUSES.includes(approvalStatus);
    const isEsigningLocked = signRequestStatus && ESIGNING_LOCKED_STATUSES.includes(signRequestStatus);
    const getLockedReason = () => {
        if (isEsigningLocked) {
            return `ESIGNING:${signRequestStatus}`;
        }
        if (isApprovalLocked) {
            return `APPROVAL:${approvalStatus}`;
        }
        return undefined;
    };
    const document = {
        name: name || '',
        type: type || DocumentType.Unknown,
        locked: isApprovalLocked || isEsigningLocked,
        lockedReason: getLockedReason(),
    };
    return Object.assign(Object.assign({}, rest), { isPleditorDownloadAvailable, document });
};
